import { useEffect, useState } from 'react';
import http from 'src/services/httpService';
import errorHandler from '../../utils/error-handler';

import WelcomeStep from './steps/WelcomeStep';
import BasicDataStep from './steps/BasicDataStep';
import PasswordStep from './steps/PasswordStep';
import MicrosoftStep from './steps/MicrosoftStep';

const OnboardingContainer = ({ onFinish, tipoAcessoSSO }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [meusDados, setMeusDados] = useState(null);
  const [stepError, setStepError] = useState(null);

  const allSteps = [WelcomeStep, BasicDataStep, MicrosoftStep, PasswordStep];
  const steps = tipoAcessoSSO
    ? allSteps.filter((step) => step !== PasswordStep)
    : allSteps;

  const isLastStep = currentStep === steps.length - 1;
  const StepComponent = steps[currentStep];

  useEffect(() => {
    http
      .post('/Colaborador/ObterMeusDados')
      .then((res) => {
        setMeusDados(res.data);
      })
      .catch(() => {});
  }, []);

  const handleNext = async (
    dadosAtualizados,
    options = { validarAgora: false }
  ) => {
    setStepError(null);

    const dadosParaSalvar = {
      ...meusDados,
      ...(dadosAtualizados ?? {}),
    };

    if (options.validarAgora) {
      try {
        await http.post('/Colaborador/SalvarAlteracaoDados', {
          meusDados: dadosParaSalvar,
        });

        setMeusDados(dadosParaSalvar);
        setCurrentStep((prev) => prev + 1);
      } catch (err) {
        const mensagem = err?.response?.data?.errorMessage;
        setStepError(mensagem);
        errorHandler(err);
      }
      return;
    }

    if (isLastStep) {
      try {
        const payloadFinal = {
          ...dadosParaSalvar,
          visualizouOnboardGame: true,
        };

        await http.post('/Colaborador/SalvarAlteracaoDados', {
          meusDados: payloadFinal,
        });

        onFinish();
      } catch (err) {
        const mensagem = err?.response?.data?.errorMessage;
        setStepError(mensagem);
      }
      return;
    }

    setMeusDados(dadosParaSalvar);
    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setStepError(null);
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  return (
    <div
      style={{ height: '100%', minHeight: '100vh', padding: '12px 48px 102px' }}
    >
      {meusDados && (
        <StepComponent
          meusDados={meusDados}
          onNext={handleNext}
          onBack={handleBack}
          currentStep={currentStep}
          totalSteps={steps.length}
          error={stepError}
        />
      )}
    </div>
  );
};

export default OnboardingContainer;
